import { pascalCase } from "pascal-case";
import React from "react";
import { useSelector } from "react-redux";
import { inspectionSelector } from "../../redux/inspectionSlice";

const PreviewDetail = ({ title }) => {
  const inspection = useSelector(inspectionSelector);
  const keys = Object.keys(inspection[title]);
  return (
    <>
      <h3 className="selectedTitle">
        {title !== "mAndE" ? pascalCase(title || "") : "M&E"}
      </h3>
      <div className="card">
        <div className="row">
          {title !== "description" ? (
            keys?.map((key, index) => (
              <div className="col-lg-4" key={index}>
                <div className="infoText">
                  <label>{key && pascalCase(key)}</label>
                  <h4>{inspection[title][key]}</h4>
                </div>
              </div>
            ))
          ) : (
            <div className="col-lg-4">
              <div className="infoText">
                <h4>{inspection[title]}</h4>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PreviewDetail;
